import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import './ErrorOrMaintenancePage.css';

const ErrorOrMaintenancePage = ({ isMaintenance }) => {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline();

    tl.from(titleRef.current, {

      y: -20,
      duration: 0.6,
      ease: 'power3.out',
    })
      .from(subtitleRef.current, {

        y: 20,
        duration: 0.6,
        ease: 'power3.out',
      }, "-=0.4");
  }, []);

  return (
    <section className="error-maintenance-container">
      <h1 className="error-maintenance-title" ref={titleRef}>
        OPS! ALGO NÃO SAIU COMO ESPERADO.
      </h1>
      <h2 className="error-maintenance-subtitle" ref={subtitleRef}>
        {isMaintenance ? (
          <>
            Estamos realizando melhorias. Tente novamente em breve.
          </>
        ) : (
          <>
            O conteúdo solicitado não está disponível. Verifique o link ou volte à página inicial.
          </>
        )}
      </h2>
    </section>
  );
};

export default ErrorOrMaintenancePage;
